// BESTIE SCREENING PACKAGES **************************************************************
// pathname: /api/billing/packages
// ************************************************************************************************
import useSWR from 'swr';
import { fetcherScreening } from '@utils/data-fetching/fetcherScreening';
import type { ApiSchemaScreening } from '@type/api/apiUtilityFnScreening';

interface UseSwrBestieScreeningPackagesProps {
  shouldFetch?: boolean;
}

type ScreeningPackageResponse = ApiSchemaScreening<'Purchase.ScreeningPackage'>[];

/**
 * @description SWR: fetch bestie screening packages list.
 * @param props - { UseSwrBestieScreeningPackagesProps } - Configuration object with optional shouldFetch.
 */
export const useSwrBestieScreeningPackages = (props?: UseSwrBestieScreeningPackagesProps) => {
  const { shouldFetch = true } = props ?? {};

  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSWR<ScreeningPackageResponse>(
    shouldFetch ? '/api/billing/packages' : null,
    async (url: string) => {
      const response = await fetcherScreening<ScreeningPackageResponse>(url);
      if (response.error) {
        throw new Error('Failed to fetch screening packages');
      }
      return response.data as ScreeningPackageResponse;
    },
    {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000 * 5, // 5 minutes
    },
  );

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
